import React from "react";

export default function TextContainer({
  bgLink,
  mobileBg,
  title,
  subTitle,
  description,
  inverted,
}) {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <img className="md:block hidden w-full h-full absolute" src={bgLink} alt="background" />
      <img className="md:hidden w-full h-full absolute" src={mobileBg} alt="background" />

      <div className=" flex flex-col items-center justify-center text-center text-white font-Helvetica z-10">
        <div className="font-Red-Undead text-4xl lg:text-7xl lg:w-full sm:w-60 w-48 2xl:text-[100px] order-1">
          {title}
        </div>

        <div
          className={` text-lg lg:text-2xl 2xl:text-[32px] font-bold my-8 w-1/2 ${
            inverted ? "uppercase order-3" : "order-2"
          }`}
        >
          {subTitle}
        </div>
        <div
          className={` text-xs lg:text-xl 2xl:text-2xl my-8 sm:w-60 w-48 lg:w-1/2 ${
            inverted ? "order-2" : "order-3"
          }`}
        >
          {description}
        </div>
      </div>
    </div>
  );
}
